import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Section, Container, SectionTitle } from '../styles/StyledComponents';
import profileImage from '../assets/images/profile.png';

const AboutContainer = styled(Container)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  align-items: center;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const AboutImage = styled(motion.div)`
  position: relative;
  
  img {
    width: 100%;
    border-radius: 8px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  }
  
  &:before {
    content: '';
    position: absolute;
    top: -20px;
    left: -20px;
    width: 100%;
    height: 100%;
    border: 2px solid var(--primary-blue);
    border-radius: 8px;
    z-index: -1;
  }
`;

const AboutContent = styled(motion.div)`
  h3 {
    color: var(--primary-blue);
    margin-bottom: 1rem;
  }
  
  p {
    margin-bottom: 1.5rem;
    color: var(--dark-blue);
    line-height: 1.8;
  }
`;

const AboutTitle = styled.h3`
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 1rem;
`;

const AboutName = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 1.5rem;
`;

const AboutButton = styled.a`
  display: inline-block;
  padding: 0.75rem 1.5rem;
  background-color: var(--primary-blue);
  color: var(--white);
  border-radius: 8px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  
  &:hover {
    background-color: var(--secondary-blue);
    transform: translateY(-2px);
    box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
  }
`;

const About: React.FC = () => {
  return (
    <Section id="about">
      <Container>
        <SectionTitle
          as={motion.h2}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          About Me
        </SectionTitle>
        
        <AboutContainer>
          <AboutImage
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <img src={profileImage} alt="Karen Lorca" />
          </AboutImage>
          
          <AboutContent
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <AboutTitle>PHARMACIST</AboutTitle>
            <AboutName>Karen Mae Lorca, RPh</AboutName>
            <p>
              Dedicated and detail-oriented healthcare professional with over 10 years of experience in pharmacy management, 
              regulatory compliance, and patient care. Recently certified in medical billing and coding (ICD-10, CPT, HCPCS), 
              equipping me with expertise in claims processing, revenue cycle management, and healthcare documentation.
            </p>
            <p>
              Adept at streamlining workflows, ensuring accuracy in administrative tasks, and leveraging technology to enhance 
              efficiency. Passionate about improving patient outcomes through precise documentation, data-driven solutions, and 
              innovative healthcare practices. Seeking to combine my pharmacy background with administrative and coding skills 
              to support healthcare providers and organizations in delivering exceptional care.
            </p>
            <AboutButton href="#contact">Download My CV</AboutButton>
          </AboutContent>
        </AboutContainer>
      </Container>
    </Section>
  );
};

export default About;
